export const COVERT_PT_BR = {
	label: "Editar couverts",
	editCouvert: "Editar couvert",
	newCouvert: "Adicionar couvert",
	saveChanges: "Salvar alterações",
	createCouvert: "Criar couvert",
	male: "Masculino",
	female: "Feminino",
	mesas: "Mesas",
	active: "Ativo",
	disabled: "Inativo",
	edit: "Editar",
	add: "Adicionar",
	cancel: "Cancelar",
	delete: "Excluir",
	emptyState: {
		title: "Ainda não tem nada por aqui",
		subtitle: "Quando adicionar um novo couvert, ele aparecerá aqui.",
	},
	deleteModal: {
		title: "Deseja excluir esse couvert?",
		firstDescription:
			"Ao confirmar, você não conseguirá mais visualizar o couvert e não conseguirá aplicá-lo em operações no PDV.",
		secondDescription: "Os registros no relatório permanecerão no histórico.",
		cancel: "Cancelar",
		confirm: "Excluir couvert",
	},
	columns: {
		public: "Público",
		name: "Nome",
		category: "Categoria",
		price: "Preço",
		fiscalProfile: "Perfil fiscal",
		fiscalProductGroup: "Grupo fiscal",
	},
	placeholders: {
		name: "Defina o nome do seu Couvert",
		public: "Selecione o público",
		category: "Selecione a categoria",
	},
	alert: {
		title:
			"Ao habilitar o modo fiscal, os couverts foram desabilitados, atualize os dados fiscais dos couverts para habilitá-los novamente.",
		message:
			"Os dados fiscais de couvert são obrigatórios para a emissão fiscal. Caso ainda não tenha dados fiscais de couvert, adicione ",
		action: "clicando aqui",
	},
	error: {
		value: {
			required: "Esse campo é obrigatório",
			value: "O valor do couvert deve ser menor ou igual ao limite de pós-pago",
		},
		name: {
			required: "Nome é obrigatório",
			maxLength: "Nome só pode ter até {{maxLength}} caracteres",
		},
		category: {
			required: "Categoria é obrigatório",
			maxLength: "Categoria só pode ter até {{maxLength}} caracteres",
		},
		kind: {
			required: "Público é obrigatório",
		},
	},
};

export type CouvertTranslations = typeof COVERT_PT_BR;
